module.exports = __webpack_public_path__ + "media/images/emblems/Juriens-coat_of_arms-fac7759ff5540bf19c188451b11a4295.svg";